module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Home")]), _vm._v(" "), _c('plaid-link'), _vm._v(" "), _c('el-table', {
    staticClass: "top",
    attrs: {
      "data": _vm.accounts
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "institution_name",
      "label": "Institution",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "subtype",
      "label": "Sub Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "current",
      "label": "Balance"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticClass: "top",
    attrs: {
      "data": _vm.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "item.institution_name",
      "label": "Institution",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uid",
      "label": "UID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "access_token",
      "label": "Access Token"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item.webhook",
      "label": "Webhook"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "top",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "header": "Plaid Transaction Count"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.plaidTransactionCount))])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "cards",
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "header": "User Transaction Count"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.transactionCount))])])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticClass: "top",
    attrs: {
      "data": _vm.transactions,
      "default-sort": {
        prop: 'date',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "date",
      "label": "Date",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "amount",
      "label": "Amount",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "category",
      "label": "Category",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "label": "Pending",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.pending ? 'true' : 'false') + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "name",
      "label": "Name"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffcaa258"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 225
// module chunks = 1